import { connect } from 'react-redux';
import { CaseDetails } from './CaseDetails';
import { casesActions } from 'src/redux/cases/casesActions';
import { getCurrentCase, getCurrentCaseLoading, getCurrentCaseApplicants, getAutoPlay } from 'src/redux/cases/casesSelectors';
import { getI18n, getRealm } from 'src/redux/core/coreSelectors';
import { withI18nExist } from 'src/shared/helpers/pagesHelpers';
import { getCommentsPermission } from 'src/redux/auth/authSelectors';
var mapStateToProps = function (state) { return ({
    i18n: getI18n(state),
    realm: getRealm(state),
    currentCase: getCurrentCase(state),
    isCaseLoading: getCurrentCaseLoading(state),
    isCommentDisplayed: getCommentsPermission(state),
    autoPlay: getAutoPlay(state),
    applicants: getCurrentCaseApplicants(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    fetchCaseDetails: function (caseToken) { return dispatch(casesActions.fetchCurrentCaseDetailsRequested(caseToken)); },
    updateTemplate: function (template, caseToken) { return dispatch(casesActions.updateTemplateRequested(template, caseToken)); },
    updateCurrentCaseHistory: function (history) { return dispatch(casesActions.updateCurrentCaseHistoryRequested(history)); },
    updateCurrentCaseComment: function (comment) { return dispatch(casesActions.updateCurrentCaseCommentRequested(comment)); },
    clearCurrentCase: function () { return dispatch(casesActions.clearCurrentCase()); },
    updateCaseIsLoading: function (isLoading) { return dispatch(casesActions.updateCurrentCaseLoading(isLoading)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(withI18nExist(CaseDetails));
